import { makeAsyncAction } from '../../../ui-lottery';
import { makeAsyncResetAction } from "../../../ui-lottery/src/utils/async_utils";
import * as types from '../constants/actions';
import * as api from '../api';
import { decodeEvents } from '../utils/asset';
import { keysToSnakeCase } from "../../../ui-lottery/src/utils/object_utils";

export const fetchEvents = makeAsyncAction(
  types.FETCH_EVENTS,
  (type, id, query) => () => api.fetchEvents(type, id, keysToSnakeCase(query)),
  undefined,
  {
    success: (dispatch, {type, payload}) => dispatch({ type, payload: decodeEvents(payload.RECDATA) })
  }
);

export const resetEvents = makeAsyncResetAction(types.RESET_EVENTS);
